/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_LeadInputs */

const en_mk_start_lead = /** @type {(inputs: Mk_Start_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to install on anybody’s machine, no API keys for you to buy, no mandatory data migration. You can do the steps below while your coffee cools.`)
};

const id_mk_start_lead = /** @type {(inputs: Mk_Start_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pemasangan di komputer siapa pun, tidak ada kunci API yang perlu Anda beli, tidak ada migrasi data wajib. Anda bisa menjalankan langkah di bawah sambil menunggu kopi.`)
};

/**
* | output |
* | --- |
* | "Nothing to install on anybody’s machine, no API keys for you to buy, no mandatory data migration. You can do the steps below while your coffee cools." |
*
* @param {Mk_Start_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_lead = /** @type {((inputs?: Mk_Start_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_lead(inputs)
	return en_mk_start_lead(inputs)
});